var cmsForm2022 = function(formID,config={}){
  this.formID = formID;
  this.form = document.getElementById(formID);
  this.config = {
    timezone:"Pacific/Honolulu", // hawaii timezone
    //timezone:"Antarctica/Casey",
    timezoneOffset:-10,
    ...config
  };

  if(formID){
    this.layout();
    this.events();
    this.loadDefaults();
  }
  else{
    this.formID = "body";
    this.form = document;

  }
}

cmsForm2022.prototype.events = function(){
  var self = this;
  if(this.form.querySelector("button[type='submit']")){
    this.form.querySelector("button[type='submit']").addEventListener("click",function(e){
      e.preventDefault();
      self.submit();
    });
  }

  if(document.querySelector("button[data-formSubmit]")){
    document.querySelector("button[data-formSubmit]").addEventListener("click",function(e){
      e.preventDefault();
      self.submit();
    });
  }
}

cmsForm2022.prototype.layout = function(){

  this.form.classList.add("cmsForm");
  this.form.setAttribute("enctype","multipart/form-data");
  if(this.form.querySelector("button[type='submit']")){
    this.form.querySelector("button[type='submit']").innerHTML = this.config.submitCTA || "Submit";
  }
  if(document.querySelector("button[data-formSubmit]")){
    document.querySelector("button[data-formSubmit]").innerHTML = this.config.submitCTA || "Submit";
  }

  this.fieldLabels();

  this.checkboxToggles();

  this.imageFields();

  this.dateFields();

  this.timeFields();

  this.selectData();

}




cmsForm2022.prototype.selectData = async function(){
  var self = this;
  var selects = this.form.querySelectorAll("select");
  for(let i=0;i<selects.length;i++){
    var s = selects[i];
    if(s.getAttribute("data-options")){
      for(var j=s.options.length-1;j>=0;j--){
        s.options[j].remove();
      }

      if(s.options.length == 0){

        if(s.getAttribute("data-options")){
          var optionurl = s.getAttribute("data-options");



          var res = await fetch(optionurl,{
            method:"GET",
            headers:{
              "Content-Type":"application/json",
              "Accept":"application/json"
            }
          });
          var data = await res.json();

          this.renderSelectData(s,data);


        }
      }
    }
  }
};

cmsForm2022.prototype.renderSelectData = function(s,data){
  var optionurl = s.getAttribute("data-options");
  var required = s.getAttribute("data-required");
  var optionname = s.getAttribute("name");

  if(s.classList.contains("checkbox")){
    // RENDER AS CHECKBOXES
    var checkboxHolder = document.createElement("div");
    checkboxHolder.classList.add("checkboxHolder");

    data.forEach((value)=>{
      var option = document.createElement("label");
      option.classList.add("checkbox");
      var checkbox = document.createElement("input");
      checkbox.setAttribute("type","checkbox");
      checkbox.setAttribute("name",optionname);
      if(required){
        checkbox.setAttribute("data-required","required");
      }
      checkbox.setAttribute("value",value);


      if(this.editData && this.editData[optionname]){
        var valueArray = this.editData[optionname].split(",");
        var selectedOptions = [];

        if(valueArray.includes(value)){
          checkbox.checked = "checked";
        }
      }


      option.innerHTML = value;
      option.append(checkbox);
      checkboxHolder.append(option);


    });
    s.parentNode.insertBefore(checkboxHolder,s);
    checkboxHolder.parentNode.classList.add("checkboxLabel");
    s.remove();
    return;
  }
  else{
    var blankOption = document.createElement("option");
    blankOption.setAttribute("value","");
    blankOption.text = s.getAttribute("placeholder");
    blankOption.selected = true;
    s.prepend(blankOption);

    data.forEach((value)=>{
      var o = document.createElement("option");
      o.setAttribute("value",value);
      o.innerText = value;

      if(this.editData && this.editData[optionname]){
        if(s.multiple){
          var valueArray = this.editData[optionname].split(",");
          var selectedOptions = [];


          if(valueArray.includes(keyvalue)){
            o.selected = "selected";
          }

        }
        else{

          if(this.editData[optionname] == value){
            o.selected = "selected";
          }

        }
      }
      s.append(o);

    });


  }

};

cmsForm2022.prototype.stripslashes = function(str) {

  return (str + '').replace(/\\(.?)/g, function (s, n1) {
    switch (n1) {
    case '\\':
      return '\\';
    case '0':
      return '\u0000';
    case '':
      return '';
    default:
      return n1;
    }
  });
}

cmsForm2022.prototype.fieldLabels = function(){
  var fields = this.getFields();
  for(let i =0;i<fields.length;i++){
    var f = fields[i];
    var label = f.getAttribute("placeholder");
    if(label && label !== "" && !f.parentNode.querySelector("span")){
      var span = document.createElement("span");
      if(f.getAttribute("data-required") == "true"){
        label += " <div class='requiredLabel'>*</div>";
        f.setAttribute("placeholder",f.getAttribute("placeholder") + " *");
      }

      span.innerHTML = label;
      f.parentNode.insertBefore(span,f);
      f.parentNode.classList.add("withLabel");
    }


    var checkInput = (f) => {
      if(f.getAttribute("type") == "date"){
        f.parentNode.classList.add("withLabel");
        f.parentNode.classList.add("large");
      }
      else if(f.value == ""){
        f.parentNode.classList.remove("withLabel");
      }
      else if(f.value !== ""){

        f.parentNode.classList.add("withLabel");

      }
    };



    f.addEventListener("keyup",function(e){
      var f = e.currentTarget;
      checkInput(f);
    });
    checkInput(f);



  }
};


cmsForm2022.prototype.edit = async function(data){
  var self = this;
  var initialData = data;

  this.editData = data;
  if(this.config.editData){
    await new Promise((resolve,reject)=>{
      setTimeout(()=>{ resolve(true) },505);
    });
    var formDataKey = data;
    var res = await fetch(this.config.editData,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Accept":"application/json",
      },
      body:JSON.stringify(data)
    });
    data = await res.json();

    //this.reset();
    this.editData = data;

  }

  var fields = this.getFields();
  this.editing = true;

  Object.keys(initialData).forEach(key=>{
    var inputEditKey = this.form.querySelector("input[name='"+key+"']");
    if(!inputEditKey){
      var inputEditKey = document.createElement("input");
      inputEditKey.setAttribute("type","hidden");
      inputEditKey.setAttribute("name",key);
      this.form.append(inputEditKey);
    }
    inputEditKey.value = initialData[key];

  });




  if(this.form.querySelector("button[type='submit']")){
     this.form.querySelector("button[type='submit']").innerHTML = this.config.editCTA || "Submit";
  }

  if(document.querySelector("button[data-formSubmit]")){
     document.querySelector("button[data-formSubmit]").innerHTML = this.config.editCTA || "Submit";
  }

  if(this.config.beforeEdit){
    this.config.beforeEdit(data);
  }


  for(let i =0; i<fields.length;i++){
    var f = fields[i];
    if(this.config.editIgnore && this.config.editIgnore.includes(f.getAttribute("name"))){
      continue;
    }

    var fieldValue = data[f.getAttribute("name")] ? data[f.getAttribute("name")] : "";

    if(f.getAttribute("type") == "checkbox"){

      if(this.form.querySelectorAll("input[name='"+f.name+"']").length > 1){
        // Multiple Checkboxes
        fieldValueArray = fieldValue.split(",");

        if(fieldValueArray.includes(f.value)){
          f.setAttribute("checked","checked");
          f.checked = true;
        }
      }
      else{
        if(fieldValue == ""){
          f.checked = false;
          f.removeAttribute("checked");
        }
        else{
          f.setAttribute("checked","checked");
          f.checked = true;
        }
      }
    }
    else{
        f.value = fieldValue;

        if(f.classList.contains("dateFieldInput")){
          this.datePickerField = f.parentNode.parentNode;
          this.dateFieldPickerUpdateValue(f.value);
        }
    }
    if(f.multiple){
      var valueArray = fieldValue.split(",");
      var selectedOptions = [];

      Array.from(f.options).map(o=>{
        if(valueArray.includes(o.value)){
          o.selected = "selected";
        }
      });



    }
    else if(f.options){
      await new Promise((resolve,reject)=>{
        setTimeout(()=>{
          Array.from(f.options).forEach(o=>{

            if(o.value == fieldValue){
              o.selected = "selected";

            }
          });
          resolve(true);
        },100);

      });



    }




    var imageField = this.form.querySelector(".imageField[data-name='"+f.getAttribute("name")+"']");
    if(imageField && data[f.getAttribute("name")]){
      if(!imageField.querySelector("img")){
        self.populateImageField(imageField,data[f.getAttribute("name")]);
      }
    }
  }
  this.checkboxToggles();
  this.fieldLabels();


  if(this.config.afterEditLoad){
    this.config.afterEditLoad();
  }
  this.hideLoader();
  this.form.style.height = "auto";
  this.form.classList.remove("hide");

};


cmsForm2022.prototype.submit = function(){
  var self = this;

  if(this.config.beforeValidate){
    this.config.beforeValidate();
  }

  if(this.validate()){


    var formData = new FormData();
    var fields = this.getFields();
    fields.forEach(f=>{
      var name = f.getAttribute("name");
      var value = f.value;
      if(f.getAttribute("type") == "checkbox" || f.getAttribute("type") == "radio"){


        if(f.checked){
          if(formData.has(name)){
            value = formData.get(name) + "," + value;
            formData.set(name,value);
          }
          else{
            formData.append(name,value);
          }
        }
      }
      else if(f.getAttribute("type") == "select"){
        var selectedOption = f.options[f.selectedIndex];
        formData.append(name,selectedOption.value);
      }
      else{
        formData.append(name,value);
      }
    });

    if(this.config.validateOnly){
      if(this.config.callback){
        this.config.callback(formData);
      }
      return false;
    }


    if(self.editing)
    {
      this.showLoader(this.config.editMessage || "Modifying");
    }
    else{
      this.showLoader(this.config.submitMessage || "Submitting");
    }


    if(this.config.beforeSubmit){
      formData = this.config.beforeSubmit(formData);
    }

    formData.append('timezone',this.config.timezone);





    fetch(this.form.getAttribute("action"),{
      method:"POST",
      body:formData,
      headers:{
        Accept:"application/json",
        //"Content-Type":"application/json"
      }
    }).then(res=>res.text())
    .then(body=>JSON.parse(body))
    .then(data=>{

      if(data.error){
        setTimeout(()=>{
          self.form.scrollIntoView(true);
          this.errorMessage(data.message ? data.message : data.error);
          
          self.form.style.height = "auto";
          
          self.hideLoader();
          

          self.form.classList.remove("hide");
        },180);
      
        
      }
      else{
        if(self.config.callback){
          self.config.callback(data);
        }
        setTimeout(()=>{
          self.form.classList.remove("hide");

          self.form.style.height = "auto";
          if(self.loader){
            self.hideLoader();
          }
          

          if(!self.editing){
            var labels = self.form.querySelectorAll("label");
            for(let i = 0;i < labels.length;i++){
              labels[i].style.display = "none";
            }

            var buttons = self.form.querySelectorAll("button");
            for(let i =0;i<buttons.length;i++){
              buttons[i].style.display = "none";
            }

            var fields = self.form.querySelectorAll(".imageField");
            for(let i =0;i<fields.length;i++){
              fields[i].style.display = "none";
            }
          }

          if(self.form.querySelector(".formSuccess")){
            if(self.editing && self.config.editResponse){
                self.form.querySelector(".formSuccess").innerHTML = self.config.editResponse;
            }
            else if(!self.editing && self.config.submitResponse){
                  self.form.querySelector(".formSuccess").innerHTML = self.config.submitResponse;
            }
            self.form.querySelector(".formSuccess").classList.add("show");

          }

        },200);

      }


    });



  }
};

cmsForm2022.prototype.hideLoader = function(){
  if(this.loader){
    this.loader.classList.remove("show");
  }
}; 

cmsForm2022.prototype.showLoader = function(message){
  var self = this;
  if(this.config.loaderID){
    this.loader = document.getElementById(this.config.loaderID);
    if(this.loader){
      this.loader.classList.add("show");
    }
    
  }
  else{
    this.form.classList.add("hide");
    if(this.loader){
      this.loader.remove();
    }

    this.loader = document.createElement("div");
    this.form.parentNode.insertBefore(this.loader,this.form);
    this.loader.classList.add("cmsLoader");

    this.loader.innerHTML = '<div class="loaderHolder"><div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div><br/>'+message+'</div>';


    
  }

  var formBounds = this.form.getBoundingClientRect();
  setTimeout(function(){
    self.loader.classList.add("show");

  },500);

  setTimeout(function(){
    self.form.style.height = "0px";

  },501);

  setTimeout(function(){

  },502);



}

cmsForm2022.prototype.reset = function(){
  this.editing = false;
  this.editData = false;
  this.form.querySelector(".formSuccess") && this.form.querySelector(".formSuccess").classList.remove("show");
  this.form.style.height = "auto";
  this.form.classList.remove("hide");
  if(this.form.querySelector("button[type='submit']")){
     this.form.querySelector("button[type='submit']").innerHTML = this.config.submitCTA || "Submit";
  }
  this.hideLoader();
  this.layout();


  var fields = this.getFields();
  for(let i = 0; i<fields.length;i++){
    if(this.config.editIgnore && this.config.editIgnore.includes(fields[i].name)){

    } else if(fields[i].type == "checkbox"){

    }
    else{
      fields[i].value = "";
    }

  }

  var labels = this.form.querySelectorAll("label");
  for(let i = 0;i < labels.length;i++){
    labels[i].style.display = "block";
  }

  var buttons = this.form.querySelectorAll("button");
  for(let i =0;i<buttons.length;i++){
    buttons[i].style.display = "block";
  }

  var fields = this.form.querySelectorAll(".imageField");
  for(let i =0;i<fields.length;i++){
    fields[i].style.display = "block";
  }



  this.loadDefaults();

  if(this.config.onReset){
    this.config.onReset();
  }
}

cmsForm2022.prototype.loadDefaults = function(){
  if(!this.config.defaultDataUrl) return;
  var self = this;
  fetch(this.config.defaultDataUrl,{
    method:"GET",
    headers:{
      Accept:"application/json"
    }
  }).then(res=>res.json())
  .then(data=>{
    self.edit(data,true);
  });

};


cmsForm2022.prototype.getFields = function(){
  var inputs  = this.form.querySelectorAll("input");
  var textareas = this.form.querySelectorAll("textarea");
  var selects = this.form.querySelectorAll("select");
  var fields = [...inputs,...textareas,...selects];
  return fields;
}

cmsForm2022.prototype.validate = function(){
  var fields = this.getFields();

  var errorMessage = this.form.getElementsByClassName("errorMessage");
  if(errorMessage.length > 0){
    errorMessage[0].remove();
  }

  var valid = true;
  for(let i=0;i<fields.length;i++){
    var f = fields[i];
    f.classList.remove("error");
    if(f.classList.contains("dateFieldInput") || f.classList.contains("timeFieldInput")){
      f.parentNode.classList.remove("error");
    }

    if(f.getAttribute("data-fieldQuerySelector")){
      var associatedFields = document.querySelectorAll(f.getAttribute("data-fieldQuerySelector"))
      for(let q=0;q<associatedFields.length;q++){
        associatedFields[q].classList.remove("error");
      }

    }
    if(f.getAttribute("data-required")){
      if(f.type == "checkbox"){
        var checked = this.form.querySelectorAll("input[name='"+f.getAttribute("name")+"']:checked");
        if(checked.length > 0){
          f.parentNode.classList.remove("error");



        } else {
          valid = false;
          f.parentNode.classList.add("error");
        }


      }
      else{
        if(f.value == ""){
          valid = false;

          if(f.getAttribute("data-fieldQuerySelector")){
            var associatedFields = document.querySelectorAll(f.getAttribute("data-fieldQuerySelector"));
            for(let q=0;q<associatedFields.length;q++){
              associatedFields[q].classList.add("error");
            }


          }

          if(f.classList.contains("dateFieldInput") || f.classList.contains("timeFieldInput")){
            f.parentNode.classList.add("error");
          }

          f.classList.add("error");
        }
      }

    }
  }
  if(!valid){
    this.errorMessage("Missing Required Fields");

  }

  return valid;
};

cmsForm2022.prototype.errorMessage = function(message){
  if(this.errorDiv){
    this.errorDiv.remove();
  }
  if(this.errorTimer){
    clearTimeout(this.errorTimer);
  }
  var self = this;
  this.errorDiv = document.createElement("div");
  this.errorDiv.innerHTML = message;
  this.errorDiv.classList.add("errorMessage");
  this.form.prepend(this.errorDiv);
  setTimeout(()=>{
    self.errorDiv.classList.add("show");
  },100);

  this.errorTimer = setTimeout(()=>{
    self.errorDiv.classList.remove("show");
  },10000);

  var firstError = this.form.querySelector(".error");
  if(firstError){
    window.scrollTo({top:firstError.getBoundingClientRect().top + window.scrollY-300,behavior:"smooth"});
  }
  else{
    window.scrollTo({top:0,behavior:"smooth"});
  }
  //this.form.scrollIntoView(true);
};
